import moment from 'moment/moment';

export const DEFAULT_DATE_FORMAT = 'DD-MM-YYYY';

export const dateFromString = (stringDate, dateFormat) =>
    moment(stringDate, dateFormat || DEFAULT_DATE_FORMAT);
